import { useEffect, useRef } from "react";

const FOCUSABLE =
  'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

export function useFocusTrap(isActive, containerRef) {
  const previousFocus = useRef(null);

  useEffect(() => {
    if (!isActive || !containerRef.current) return;

    previousFocus.current = document.activeElement;

    const container = containerRef.current;
    const focusable = container.querySelectorAll(FOCUSABLE);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (first) first.focus();

    const handleKeyDown = (e) => {
      if (e.key !== "Tab") return;

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last?.focus();
        }
      } else if (document.activeElement === last) {
        e.preventDefault();
        first?.focus();
      }
    };

    container.addEventListener("keydown", handleKeyDown);

    return () => {
      container.removeEventListener("keydown", handleKeyDown);
      if (previousFocus.current?.focus) {
        previousFocus.current.focus();
      }
    };
  }, [isActive, containerRef]);
}
